<template>
  <kendo-window ref="kendoWindowRef"
                :title="'솔루션마스터목록'"
                :modal="true"
                :width="'982px'"
                style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
                @open="onClickSearch"
                @close="onCloseKendoWindow">
    <div class="pwindow">
      <div class="k-window-content k-content">
        <div class="k-desc">
          <ul class="k-sea">
            <li class="w20">
              <kendo-dropdownlist
                      ref="searchCdRef"
                      id="searchCd"
                      :data-source="searchTextData"
                      :data-text-field="'cdNm'"
                      :data-value-field="'cdNameSpace'"
                      :style="'width: 100%;'"
              >
              </kendo-dropdownlist>
            </li>
            <li class="w50">
              <kendo-maskedtextbox
                      ref="searchTextRef"
                      id="searchText"
                      :style="'width: 100%;'"
                      :placeholder="'검색어를 입력하세요.'"
              >
              </kendo-maskedtextbox>
            </li>
            <li class="w20">
              <button class="mid_btn orange" @click="onClickSearch">
                <span class="k-icon k-i-zoom"></span>
                검색
              </button>
            </li>
          </ul>
        </div>
        <!-- Kendo 영역 -->
        <kendo-grid ref="solutionMasterListWindowGridRef"
                    id="solutionMasterListWindowGrid"
                    :height="301"
                    :navigatable="true"
                    :filterable="false"
                    :sortable="true"
                    :scrollable="true"
                    :pageable-always-visible="false"
                    :reorderable="true"
                    :column-menu="false"
                    :resizable="true"
                    :selectable="'multiple row'"
                    :columns="solutionMasterListWindowColumns"
                    :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }"
        >
        </kendo-grid>
        <!-- Kendo 영역 끝 -->
        <div class="button_wrap_area">
          <ul>
            <li>
              <button class="large_btn orange" @click="onClickSet">확인</button>
            </li>
            <li>
              <button class="large_btn" @click="onClickClose">취소</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </kendo-window>
</template>

<script>
  import ApiUtil from '@/api/api.util'
  import ApiConfig from '@/api/api.config'
  import EtnersCommonUtil from '@/common/etners.common.util'
  import EtnersParseUtil from '@/common/etners.parse.util'
  import EtnersKendoGridUtil from '@/common/kendo.grid.util'

  export default {
    name   : 'SolutionMasterListWindow',
    props  : ['exceptSolCdListProps'],
    mounted: function () {
      const vm = this

      // 검색어 enter 처리
      let element = document.getElementById('searchText')
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 13

          let currentKeyCode = window.event.keyCode || e.which
          if (currentKeyCode === ENTER_KEY_CODE) {
            vm.onClickSearch(e)
          }
        }
      }
    },
    methods: {
      getSolutionList   : function (param) {
        const vm = this
        return new Promise(resolve => {

          ApiUtil.post(`${ApiConfig.platformDomain}/v1/ebmp/admin/solution/list.json`, param).then(response => {

            if (response.data === undefined || response.data.resultStatus === undefined) {
              kendo.alert('데이터가 정상적으로 조회되지 않았습니다.')
              return false
            }
            if (response.data.resultStatus.messageCode !== '2000') {
              kendo.alert(response.data.resultStatus.messageText)
              return false
            }

            let solutionListResponse = response.data.resultData

            // 공통코드 처리
            let commonCodeMap = EtnersCommonUtil.getAllCommonCodeMapUsingVuex()
            for (let i = 0; i < solutionListResponse.length; i++) {
              let row = solutionListResponse[i]
              // converting code to text (구분)
              row.cvtWmGbn = EtnersParseUtil.commonCodeToText(commonCodeMap, row.wmGbn)
            }

            resolve(solutionListResponse)
          }).catch(error => {
            console.log(error)
          })
        })
      },
      onClickSearch     : function (e) {
        // 검색 버튼 클릭 이벤트

        const vm = this

        let searchCd = vm.$refs.searchCdRef.kendoWidget().value()
        let searchText = vm.$refs.searchTextRef.kendoWidget().value()

        let searchFilterOptions = new Array()
        if (searchCd !== undefined && searchCd !== '') {
          searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: searchCd, value: searchText }))
        }
        searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ columnName: 'useYn', value: 'Y' }))

        // 부모화면에서 전달받은 검색 제외할 솔루션코드
        if (vm.$props.exceptSolCdListProps !== undefined && vm.$props.exceptSolCdListProps !== null) {
          vm.$props.exceptSolCdListProps.forEach(element => {
            // TODO : 이러한 조건을 만들어야 함
            // →  AND (T1.sol_Cd <> 1002 or (T1.sol_Cd = 1002 and T1.wm_Gbn <> 12))
            let wmGbnSplitArr = element.wmGbn.split('_')
            let wmGbn = (wmGbnSplitArr.length > 1 ? wmGbnSplitArr[1] : wmGbnSplitArr[0])
            searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ logic :'betweenOr',operator: 'ne', columnName: ['solCd', 'wmGbn'], value: [element.solCd,wmGbn] }))
            //real
            // searchFilterOptions.push(EtnersKendoGridUtil.generateFilterOption({ operator: 'ne', columnName: 'solCd', value: element }))
          })
        }

        let param = {
          loginUserToken: sessionStorage.lutk,
          skip          : 0,
          take          : 10,
          page          : 1,
          pageSize      : 10,
          filter        : searchFilterOptions,
          requestType   : 'EXPORT', // PAGING or EXPORT
        }
        vm.getSolutionList(param).then(function (response) {
          // 그리드 dataSource
          vm.$refs.solutionMasterListWindowGridRef.kendoWidget().setDataSource(response)
        })
      },
      onCloseKendoWindow: function (e) {
        /* window on close 이벤트 */

        // 검색영역 초기화
        this.$refs.searchCdRef.kendoWidget().select(0)
        this.$refs.searchTextRef.kendoWidget().value("")
        // 그리드 dataSource 초기화
        this.$refs.solutionMasterListWindowGridRef.kendoWidget().setDataSource([])
      },
      onClickSet        : function (e) {
        /* 확인 버튼 클릭 이벤트 */
        const vm = this

        let selectedRows = vm.$refs.solutionMasterListWindowGridRef.kendoWidget().select()

        if (selectedRows.length === 0) {
          kendo.alert("선택된 솔루션이 없습니다.")
          return false
        }

        vm.selectedRowDataList = []
        for (let i = 0; i < selectedRows.length; i++) {
          let rowData = vm.$refs.solutionMasterListWindowGridRef.kendoWidget().dataItem(selectedRows[i])
          vm.selectedRowDataList.push(rowData)
        }

        // 부모화면에 선택한 row data list 전달
        vm.$parent.callbackFromSolutionMasterListWindow(vm.selectedRowDataList)
        vm.onClickClose(e);
      },
      onClickClose      : function (e) {
        /* 취소 버튼 클릭 이벤트 */
        // window 닫기
        this.$refs.kendoWindowRef.kendoWidget().close()
      }
    },
    data   : function () {
      const kendoGridHeaderAttributes = {
        style: 'font-weight: bold;',
      }

      return {
        selectedRowDataList            : [],
        searchTextData                 : [
          { cdNm: "솔루션명", cdNameSpace: "solNm" },
          { cdNm: "솔루션URL", cdNameSpace: "solUrl" }
        ],
        solutionMasterListWindowColumns: [
          { selectable: 'true', width: '10%' },
          { field: 'solCd', title: '솔루션코드', width: '10%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'cvtWmGbn', title: '구분', width: '20%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'solNm', title: '솔루션명', width: '30%', headerAttributes: kendoGridHeaderAttributes },
          { field: 'solUrl', title: '솔루션URL', width: '30%', headerAttributes: kendoGridHeaderAttributes }
        ]
      }
    }
  }
</script>

<style scoped>

</style>
